import { call, put, takeEvery } from 'redux-saga/effects';
import { getBikeModelOverview } from '../../requests/get_bike_model_overview_request';
import { getBikeModelOverviewRequestSuccess, getBikeModelOverviewRequestFailure } from '../actions/get_bike_model_overview.actions';
import { GET_BIKE_MODEL_OVERVIEW_REQUEST } from '../constants/get_bike_model_overview.constants';
import { message_error } from '../../../../../components/Message';

function* getBikeModelOverviewRequest({ limit, offset, model_id }) {
    const bikes = yield call(getBikeModelOverview, limit, offset, model_id); const
        { msg } = bikes;
    if (bikes) {
        yield put(getBikeModelOverviewRequestSuccess(bikes));
    } else {
        yield put(getBikeModelOverviewRequestFailure(msg));
        message_error(msg);
    }
}

export default function* bikesOverviewSaga() {
    yield takeEvery(GET_BIKE_MODEL_OVERVIEW_REQUEST, getBikeModelOverviewRequest);
}



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Bike_model_update/redux/sagas/get_bike_model_overview.saga.js